<div class="inline-flex align-content-center toolbar-container">
  @for (tool of toolbar; track $index) {
    @if (!tool.isHidden) {
      <p-button
        #toolButtonRef
        (click)=" tool.icon.includes('info') ? openEmailInfo(toolButtonRef) : tool.command()"
        pTooltip="{{ tool.label }}"
        plain="true"
        styleClass="h-2rem w-2rem justify-content-center align-items-center p-0 overflow-visible"
        text="true"
        tooltipPosition="bottom"
        rounded="true"
      >
      @if (tool.badgeValue) {
        <p-badge
          [value]="tool.badgeValue"
          severity="primary"
          styleClass="p-badge-rounded absolute top-0 right-0"
        ></p-badge>
      }
      @if (tool.icon.includes('pi')) {
      <i class="{{ tool.icon }}" [style]="tool.iconStyle"></i>
      }@else {
        <svg-icon [key]="tool.icon" color="#424242" [style]="tool.iconStyle"></svg-icon>
      }
    </p-button>
    }
  }
</div>


